var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusiveBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 54,
    viewBox: "0 0 37 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d-495753)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1 0L2 43V0H1Z",
    fill: "#18252D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 0H36V46C36 49.3137 33.3137 52 30 52H8C4.68629 52 2 49.3137 2 46V0Z",
    fill: "url(#paint0_linear-566541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 36.5C4 34.0147 6.06638 32 8.61538 32H29.3846C31.9336 32 34 34.0147 34 36.5V45.5C34 47.9853 31.9336 50 29.3846 50H8.61538C6.06638 50 4 47.9853 4 45.5V36.5Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2149 8.04761C20.4281 8.11465 20.6143 8.24793 20.7464 8.42809C20.8786 8.60824 20.9499 8.82586 20.9499 9.04931V14.2993H25.1496C25.3417 14.2992 25.53 14.3518 25.6943 14.4514C25.8585 14.5509 25.9923 14.6936 26.0811 14.8639C26.1699 15.0343 26.2102 15.2257 26.1978 15.4173C26.1854 15.609 26.1206 15.7936 26.0105 15.951L18.661 26.451C18.5331 26.6342 18.3501 26.7719 18.1385 26.8439C17.927 26.916 17.6979 26.9186 17.4848 26.8515C17.2716 26.7844 17.0854 26.651 16.9533 26.4708C16.8212 26.2905 16.75 26.0728 16.7501 25.8493V20.5993H12.5504C12.3583 20.5994 12.17 20.5468 12.0057 20.4472C11.8415 20.3477 11.7077 20.205 11.6189 20.0347C11.5301 19.8644 11.4898 19.673 11.5022 19.4813C11.5146 19.2896 11.5794 19.1051 11.6895 18.9477L19.039 8.44766C19.1671 8.26474 19.3502 8.12743 19.5616 8.05567C19.7731 7.98392 20.002 7.98146 20.2149 8.04866V8.04761Z",
    fill: "#18252D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2155 7.04761C20.4286 7.11465 20.6148 7.24793 20.747 7.42809C20.8792 7.60824 20.9505 7.82586 20.9505 8.04931V13.2993H25.1505C25.3425 13.2992 25.5309 13.3518 25.6952 13.4514C25.8594 13.5509 25.9932 13.6936 26.082 13.8639C26.1708 14.0343 26.2112 14.2257 26.1987 14.4173C26.1863 14.609 26.1215 14.7936 26.0115 14.951L18.6615 25.451C18.5335 25.6342 18.3505 25.7719 18.1389 25.8439C17.9274 25.916 17.6983 25.9186 17.4851 25.8515C17.272 25.7844 17.0858 25.651 16.9536 25.4708C16.8215 25.2905 16.7503 25.0728 16.7505 24.8493V19.5993H12.5505C12.3584 19.5994 12.17 19.5468 12.0057 19.4472C11.8415 19.3477 11.7077 19.205 11.6189 19.0347C11.5301 18.8644 11.4898 18.673 11.5022 18.4813C11.5146 18.2896 11.5794 18.1051 11.6895 17.9477L19.0395 7.44766C19.1676 7.26474 19.3507 7.12743 19.5622 7.05567C19.7736 6.98392 20.0025 6.98146 20.2155 7.04866V7.04761Z",
    fill: "url(#paint1_linear-623711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0797 45.3399C14.4729 45.3399 13.9368 45.2152 13.4713 44.9658C13.0058 44.7165 12.6442 44.3673 12.3865 43.9185C12.1288 43.4613 12 42.9376 12 42.3474V39.3799C12 38.7897 12.1288 38.2702 12.3865 37.8213C12.6442 37.3725 13.0058 37.0233 13.4713 36.774C13.9368 36.5246 14.4729 36.3999 15.0797 36.3999C15.6949 36.3999 16.2352 36.5246 16.7007 36.774C17.1662 37.0233 17.5278 37.3725 17.7854 37.8213C18.0431 38.2702 18.172 38.7897 18.172 39.3799V42.3474C18.172 42.9376 18.0431 43.4613 17.7854 43.9185C17.5278 44.3673 17.1662 44.7165 16.7007 44.9658C16.2352 45.2152 15.6949 45.3399 15.0797 45.3399ZM15.0797 44.305C15.645 44.305 16.1022 44.1304 16.4513 43.7813C16.8004 43.4322 16.975 42.9709 16.975 42.3973V39.3674C16.975 38.7856 16.8004 38.3201 16.4513 37.9709C16.1022 37.6135 15.645 37.4348 15.0797 37.4348C14.5145 37.4348 14.0573 37.6135 13.7082 37.9709C13.3674 38.3201 13.197 38.7856 13.197 39.3674V42.3973C13.197 42.9709 13.3674 43.4322 13.7082 43.7813C14.0573 44.1304 14.5145 44.305 15.0797 44.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7987 45.3274C22.2002 45.3274 21.6682 45.2111 21.2027 44.9783C20.7455 44.7373 20.3881 44.4006 20.1304 43.9684C19.881 43.5278 19.7564 43.0249 19.7564 42.4597V39.2677C19.7564 38.6941 19.881 38.1912 20.1304 37.759C20.3881 37.3267 20.7455 36.9942 21.2027 36.7615C21.6682 36.5204 22.2002 36.3999 22.7987 36.3999C23.3972 36.3999 23.925 36.5163 24.3822 36.749C24.8394 36.9818 25.1927 37.306 25.442 37.7216C25.6997 38.1289 25.8286 38.5902 25.8286 39.1056V39.2427C25.8286 39.3259 25.787 39.3674 25.7039 39.3674H24.7563C24.6731 39.3674 24.6316 39.3259 24.6316 39.2427V39.1305C24.6316 38.6318 24.4612 38.2286 24.1204 37.9211C23.7879 37.6052 23.3473 37.4473 22.7987 37.4473C22.2418 37.4473 21.7929 37.6094 21.4521 37.9335C21.1196 38.2577 20.9533 38.69 20.9533 39.2303V42.4971C20.9533 43.0374 21.1279 43.4696 21.477 43.7938C21.8261 44.118 22.2833 44.2801 22.8486 44.2801C23.3972 44.2801 23.8294 44.1388 24.1453 43.8561C24.4695 43.5652 24.6316 43.1704 24.6316 42.6716V41.7115C24.6316 41.6783 24.615 41.6617 24.5817 41.6617H22.8984C22.8153 41.6617 22.7738 41.6201 22.7738 41.537V40.7639C22.7738 40.6808 22.8153 40.6392 22.8984 40.6392H25.7039C25.787 40.6392 25.8286 40.6808 25.8286 40.7639V42.3474C25.8286 43.3034 25.5543 44.039 25.0056 44.5544C24.4653 45.0697 23.7297 45.3274 22.7987 45.3274Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d-495753",
    x: 0,
    y: 0,
    width: 37,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear-566541",
    x1: 30,
    y1: -6.22093e-8,
    x2: 22.8994,
    y2: 31.7908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A53F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A79F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear-623711",
    x1: 21.5,
    y1: 7,
    x2: 15.5,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveBadge);
export default __webpack_public_path__ + "static/media/exclusive-badge.ce7ed9f7689197a350b5d409701cfea2.svg";
export { ForwardRef as ReactComponent };